import { render, staticRenderFns } from "./review-analysis.vue?vue&type=template&id=89903664&scoped=true&"
import script from "./review-analysis.vue?vue&type=script&lang=js&"
export * from "./review-analysis.vue?vue&type=script&lang=js&"
import style0 from "./review-analysis.vue?vue&type=style&index=0&id=89903664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89903664",
  null
  
)

export default component.exports